<a [routerLink]="['/company-profile', entityId]">
  <app-entity-name-number-record
    class="company-name-acn"
    [name]="name"
    [numberFormatted]="acn | acn"
  />
</a>
